module.exports = __webpack_public_path__ + "img/numberplateEuropeAt.09525b57.svg";